<template>
  <SelectWithSearch
    placeholder="UF"
    labelBusca="sigla"
    v-model="input"
    :disabled="disabled"
    :clearable="false"
    :label="label"
    :change="change"
    :options="ufCollection"
    :error="error"
  >
    <template slot="options" slot-scope="props">
      <div class="selected">{{ props.data.sigla }}</div>
    </template>
    <template slot="no-options"> Nenhuma UF encontrada </template>
    <template slot="selected" slot-scope="props">
      <div class="selected">{{ props.data.sigla }}</div>
    </template>
  </SelectWithSearch>
</template>

<script>
import { SelectWithSearch } from '@/components/Form';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'SelectUf',
  components: {
    SelectWithSearch,
  },
  props: {
    error: {
      type: Boolean,
      default: () => false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {},
    cityCode: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: 'UF',
    },
  },
  data() {
    return {
      input: null,
    };
  },
  async mounted() {
    await this.setUfCollection();
  },
  computed: {
    ...mapState('person', ['ufCollection']),
  },
  methods: {
    ...mapActions('person', ['setUfCollection']),
    ...mapActions('core', ['setCityByCode']),

    change(value) {
      this.$emit('input', value);
    },
  },
  watch: {
    value(current) {
      this.input = current;
    },
    async cityCode(current, previous) {
      if (current && previous !== current) {
        const city = await this.setCityByCode(current);

        this.change({ sigla: city.acronym });
      }
    },
  },
};
</script>
